import React from "react";
import { HelpCircle, Rocket, MessageCircle, Bell } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/app/common/common-components/ui/Dialog";
import PlayStoreBanner from "../../../assets/images/PlayStoreBanner.png";
import { useIntercom } from "react-use-intercom";

interface HelpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const HelpDialog: React.FC<HelpDialogProps> = ({ open, onOpenChange }) => {
  const intercom = useIntercom();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw-max-h-dvh tw-max-w-5xl tw-overflow-auto">
        <DialogHeader>
          <DialogTitle>Help</DialogTitle>
        </DialogHeader>

        <div className="tw-mt-6 tw-grid tw-grid-cols-1 tw-gap-6 md:tw-grid-cols-2 lg:tw-grid-cols-4">
          {/* Help Files */}
          <div
            className="tw-flex tw-cursor-pointer tw-flex-col tw-items-center tw-text-center hover:tw-text-primary"
            onClick={() => window.open("https://help.entegral.net", "_blank")}
          >
            <HelpCircle className="tw-size-12 tw-text-primary" />
            <div className="tw-flex tw-flex-col tw-items-center tw-leading-none">
              <h3 className="tw-text-lg tw-font-semibold">Help files</h3>
              <p className="tw-text-muted-foreground">for all systems</p>
            </div>
          </div>

          {/* Suggest a feature */}
          <div
            className="tw-flex tw-cursor-pointer tw-flex-col tw-items-center tw-text-center hover:tw-text-primary"
            onClick={() => {
              window.open("https://docs.google.com/forms/u/2/d/e/1FAIpQLSd-vKW07fFHE2me_Kv1kbHl3p6DqOCC_yhDlqO3lJuDwaFqjQ/viewform", "_blank");
            }}
          >
            <Rocket className="tw-size-12 tw-text-primary" />
            <div className="tw-flex tw-flex-col tw-items-center tw-leading-none">
              <h3 className="tw-text-lg tw-font-semibold">Suggest a feature</h3>
              <p className="tw-text-muted-foreground">or tweak for Base</p>
            </div>
          </div>

          {/* Live chat */}
          <div
            className="tw-flex tw-cursor-pointer tw-flex-col tw-items-center tw-text-center hover:tw-text-primary"
            onClick={() => {
              intercom.show();
            }}
          >
            <MessageCircle className="tw-size-12 tw-text-primary" />
            <div className="tw-flex tw-flex-col tw-items-center tw-leading-none">
              <h3 className="tw-text-lg tw-font-semibold">Live chat</h3>
              <p className="tw-text-muted-foreground">for fastest response</p>
            </div>
          </div>

          {/* Status dashboard */}
          <div
            className="tw-flex tw-cursor-pointer tw-flex-col tw-items-center tw-text-center hover:tw-text-primary"
            onClick={() => {
              window.open("https://status.entegral.net", "_blank");
            }}
          >
            <Bell className="tw-size-12 tw-text-primary" />
            <div className="tw-flex tw-flex-col tw-items-center tw-leading-none">
              <h3 className="tw-text-lg tw-font-semibold">Status dashboard</h3>
              <p className="tw-text-muted-foreground">status.entegral.net</p>
            </div>
          </div>
        </div>

        <div className="tw-mt-8 tw-flex tw-flex-col tw-items-center tw-space-y-4">
          <a href="https://play.google.com/store/apps/details?id=net.entegral.base.twa&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
            <img src={PlayStoreBanner} alt="Get it on Google Play" className="tw-h-12 tw-w-fit" />
          </a>

          <div className="tw-text-center tw-text-sm tw-text-muted-foreground">
            Made with ❤️ by{" "}
            <a href="https://www.entegral.net" className="tw-text-primary hover:tw-underline">
              Entegral
            </a>{" "}
            |{" "}
            <a href="https://www.facebook.com/entegraltechnologies" className="tw-text-primary hover:tw-underline">
              Facebook
            </a>{" "}
            |{" "}
            <a href="https://twitter.com/entegral" className="tw-text-primary hover:tw-underline">
              Twitter
            </a>{" "}
            |{" "}
            <a href="mailto:support@entegral.net" className="tw-text-primary hover:tw-underline">
              support@entegral.net
            </a>{" "}
            | help available week days 8am-4pm
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HelpDialog;
